import { freeze } from 'immer';
import { IYAxisCustomBound } from './types';

export const defaultYAxisCustomBound = freeze<IYAxisCustomBound>(
  {
    min: null,
    max: null,
    isCustomApplied: false,
    errors: null,
  },
  true,
);
